import React, { useState } from "react"

import { CrossCompanyPhoneCheck } from "../auth/CrossCompanyPhoneCheck"
import { Button } from "../styled/Button"

const YTTV32POINT5OFF_PROMO_CODE = "2022YOUTUBETV"
const YTTV10OFF_PROMO_CODE = "2021YOUTUBETVP4"
const YTPREMIUM_PROMO_CODE = "2021YOUTUBEP5"

export const YouTubeTvGetStartedComponent = () => {
  const [submissionPromoCode, setSubmissionPromoCode] = useState(YTTV10OFF_PROMO_CODE)


  const initialValues = {
    phoneNumber: ""
  }

  const getButton = (boldDescription , description, logoUrl, promoCode) => ({disabled, handleClick}) => {
    return (
      <>
        <img src={logoUrl} alt="YouTube Logo" className="mb-3"/>
        {
          promoCode === YTTV32POINT5OFF_PROMO_CODE &&
          <img src="images/YouTubeTV/YouTubeTVLogo.png" alt="YouTube Logo" className="mb-3"/>
        }
        <p><b dangerouslySetInnerHTML={{__html: boldDescription}}></b>{description}</p>
        {/* {
          promoCode === YTTV32POINT5OFF_PROMO_CODE &&
          <>
            <p className="youtube-subtitle youtube-subtitle-italic"><b>Note: By enrolling in the 50% off YouTube TV promotion, customers will lose their enrollment in any existing YouTube TV promotions offered by T-Mobile other than the YouTube Premium offer and will not be able to re-enroll in those offers in the future.</b></p>
            <p className="youtube-subtitle"><b>For Home Internet customers with Magenta MAX.</b>
              YouTube TV subscription automatically renews at $64.99/mo after first year. See full terms.</p>
          </>
        } */}
        {
          promoCode === YTTV10OFF_PROMO_CODE &&
          <p className="youtube-subtitle" >Subscription automatically renews at $64.99/mo after first year.
            YouTube TV offer is available to current T-Mobile Wireless and Home Internet service customers. See full terms.</p>
        }
        <Button style={{ marginBottom: "40px" }}
          type="button"
          className="btn"
          primary
          disabled={disabled}
          onClick={() => {
            setSubmissionPromoCode(promoCode);
            sessionStorage.setItem('promoCode', promoCode);
            handleClick();
          }}
        >
          Continue
        </Button>
      </>)
  }

  const submitButtons = [
    // getButton(
    //   `T-Mobile customers with Magenta MAX or other Premium plans <u>and</u> a Home Internet line `,
    //   `can get 50% off YouTube TV for a year. 
    //    85+ top channels of entertainment, news, live sports, & more. Unlimited DVR included and stream on 3 devices at once. 
    //    No installation, contracts, or hidden fees.`,
    //   "images/YouTubeTV/5GHomeInternetLogo.png",
    //   YTTV32POINT5OFF_PROMO_CODE
    // ),
    getButton(
      `All T-Mobile customers `,
      `can get $10/month off YouTube TV for 12 months. 85+ top channels of entertainment, news, live sports, & more.
       Unlimited DVR included and stream on 3 devices at once. No installation, contracts, or hidden fees.`,
      "images/YouTubeTV/YouTubeTVLogo.png",
      YTTV10OFF_PROMO_CODE
    ),
    getButton(
      `All T-Mobile customers `,
      `can get 3 months of YouTube Premium for free! Enjoy ad-free videos, offline, and background play viewing access on both YouTube and YouTube music.
       After trial pay $11.99/mo.`,
      "images/YouTubeTV/YTPremiumLogo.png",
      YTPREMIUM_PROMO_CODE
    ),
  ];

  return (
    <section>
      <div className="container py-5 hero3">
        <div className="row text-center">
          <div className="col">
            <h3 className="magenta text-center">Let's start your submission</h3>
          </div>
        </div>
        <div className="row text-center">
          <div className="col">
            <p>Enter your T-Mobile or Sprint phone number and choose the YouTube offers to redeem. You may redeem both offers. You will then be prompted to log in to your account.</p>
            <p>If you are a Home Internet only customer, please find your assigned billing phone number on your bill under "connected devices". </p>
            <p>If you are a T-Mobile for Business customer, please click "<a href={process.env.REACT_APP_TMO_TFB_ID_AUTH_URL} rel="noreferrer">Here</a>".</p>
            <p>
              Current YouTube TV or YouTube Premium customers will need to cancel your current subscription and re-sign up after the cancelation is completed at the end of your bill cycle.
              You can then use the unique link to apply your coupon code for the discount/free trial.
            </p>
          </div>
        </div>
        <div className="row text-center">
          <div className="col" style={{marginBottom: "6px"}}>
            <b>Start by entering your phone number</b>
          </div>
        </div>
        <div className="mx-auto col">
          <CrossCompanyPhoneCheck initialValues={initialValues} fromYoutubeComponent={true}  buttons={submitButtons} promoCode={submissionPromoCode} phoneInputClass="col-md-4 mx-auto"/>
        </div>
        <div className="mx-auto col-md-5 text-center">
          <p>
            Questions before you continue?
            Find answers <a href="https://www.t-mobile.com/tvision#faq" target="_blank" rel="noopener noreferrer">here</a>.
          </p>
        </div>
      </div>
    </section>
  )
}
